import { gql } from '__generated__';

export default gql(`
  mutation EditRegistrationBackend($input: EditRegistrationInput!) {
    editRegistration(input: $input) {
      id
    }
  }
`);
